// Convert number to words
const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function convertHundreds(num) {
  let result = '';
  if (num > 99) {
    result += ones[Math.floor(num / 100)] + ' Hundred ';
    num %= 100;
  }
  if (num > 19) {
    result += tens[Math.floor(num / 10)] + ' ';
    num %= 10;
  }
  if (num > 9) {
    result += teens[num - 10] + ' ';
    num = 0;
  }
  if (num > 0) {
    result += ones[num] + ' ';
  }
  return result.trim();
}

export function numberToWords(amount) {
  if (amount === 0) return 'Zero Dollars Only';
  
  const totalDollars = Math.floor(amount);
  const cents = Math.round((amount - totalDollars) * 100);
  
  let result = '';
  let dollars = totalDollars;
  
  if (dollars >= 1000000) {
    const millions = Math.floor(dollars / 1000000);
    result += convertHundreds(millions) + ' Million ';
    dollars %= 1000000;
  }
  
  if (dollars >= 1000) {
    const thousands = Math.floor(dollars / 1000);
    result += convertHundreds(thousands) + ' Thousand ';
    dollars %= 1000;
  }
  
  if (dollars > 0) {
    result += convertHundreds(dollars);
  }
  
  if (result.trim() === '') {
    result = 'Zero';
  }
  
  result = result.trim();
  result += totalDollars === 1 ? ' Dollar' : ' Dollars';
  
  if (cents > 0) {
    result += ' and ' + convertHundreds(cents);
    result += cents === 1 ? ' Cent' : ' Cents';
  }
  
  result += ' Only';
  
  return result;
}

